export default __webpack_public_path__ + "static/columnDefinitions-aeb7c553a9a79996918059ff55d0231b.gif";